module.exports = __webpack_public_path__ + "static/FR-2228deeaaaffffc103caa225cdde6280.jpg";